import {TStorage} from '../pages/cloud-storage/interface';
import {TAutoStatementsDecision} from '@models/auto-statements.model';
import {TUserRole} from '@auth/constants';

export type TAccountingPlatform = 'quickbooks' | 'zohobooks' | 'manual';

export const INTEGRATIONS = ['quickbooks', 'zohobooks', 'xero'] as const;
export type TIntegration = typeof INTEGRATIONS[number];
export const INTEGRATION_LABELS = {
  quickbooks: 'QuickBooks',
  xero: 'Xero',
  zohobooks: 'ZohoBooks',
};

export interface ICloudSetting {
  id: TStorage;
  name: string;
  path: string;
  folderId?: string;
}

export type TClientEmail = 'PRIMARY' | 'ADDITIONAL';
export interface IClientEmail {
    id: number;
    email: string;
    type?: TClientEmail;
}
export interface IClientPhone {
    id: number;
    phone: string;
    label?: string;
}
export interface IClient {
  id: number;
  name: string;
  username?: string;

  allowSms?: boolean;
  autoRemind?: boolean;
  createdAt?: string;
  emails?: IClientEmail[];
  additionalPhones?: IClientPhone[];
  firstLogin?: string;
  isCustomer?: boolean;
  lastLogin?: string;
  locked?: true;
  numberOfAccounts?: number;
  phone?: string;
  role?: TUserRole;

  firmId?: number;
  clientGroupId?: number;
  clientGroupName?: string;
  isFirm?: boolean;
  isClientWithFirm?: boolean;
  collapsed?: boolean;

  // Card #1571: statement auto-pull in effect for the client and what decided it, from the list and details only
  autoStatementsEnabled?: boolean;
  autoStatementsDecidedBy?: TAutoStatementsDecision;

  seek?: string;
}
